<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">Online Assessment</div>
        </div>
        <div class="con">
            <div class="title">
                Online Assessment for Australian and New Zealand Primary and Secondary Students
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="Test Questions"></el-step>
                <el-step title="Personal Information"></el-step>
                <el-step title="Submission Successful"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">Submit</el-button>
            </div>
        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <div class="step-1">
                    <div class="input-title"><span>*</span>Student Name: </div>
                    <el-input placeholder="Please Enter Student Name" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>Student Name English:</div>
                    <el-input placeholder="Please Enter Student Name English" v-model="form.nameen"></el-input>
                    <div class="input-title"><span>*</span>Email</div>
                    <el-input placeholder="Please Enter Email" v-model="form.email"></el-input>
                    <div class="input-title">Mobile Number</div>
                    <el-input placeholder="Please Enter Mobile Number" v-model="form.mobile"></el-input>
                    <div class="input-title"><span>*</span>Current Country/City:</div>
                    <el-input placeholder="Please Enter Current Country/City" v-model="form.source"></el-input>
                    <div class="input-title"><span>*</span>Student Passport Type:</div>
                   
                    <el-input placeholder="Please Enter Student Passport Type" v-model="form.source"></el-input>
                    <div class="input-title">Student Passport Number</div>
                    <el-select placeholder="Please Select Student Passport Type" v-model="form.passport_type">
                        <el-option label="Chinese Mainland" value="Chinese Mainland"></el-option>
                        <el-option label="Hong Kong" value="Hong Kong"></el-option>
                        <el-option label="Taiwan Region" value="Taiwan Region"></el-option>
                        <el-option label="Australian" value="Australian"></el-option>
                        <el-option label="New Zealand Region" value="New Zealand Region"></el-option>
                    </el-select>
                    <div class="input-title">Passport Number</div>
                    <el-input placeholder="Please Enter Passport Number" v-model="form.passport_code"></el-input>
                    <div class="input-title">Parents Name</div>
                    <el-input placeholder="Please Enter Parents Name" v-model="form.parents_name"></el-input>
                    <div class="input-title">Parents Relation</div>
                    <el-select placeholder="Please Select Parents Relation" v-model="form.parents_relation">
                        <el-option label="Father" value="Father"></el-option>
                        <el-option label="Mother" value="Mother"></el-option>
                        <el-option label="Guardian" value="Guardian"></el-option>
                    </el-select>
                    <div class="input-title"><span>*</span>WeChat:</div>
                    <el-input placeholder="Please Enter WeChat Number" v-model="form.wx_code"></el-input>
                    <div class="input-title">Message</div>
                    <el-input placeholder="Please Enter Message" v-model="form.about"></el-input>
                    <div class="input-title">Attachments</div>
                    <el-radio v-model="form.reportType" label="1">Upload Image</el-radio>
                    <el-radio v-model="form.reportType" label="2">Upload File</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">Click to Upload</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                Please upload {{ form.reportType == 1 ? 'png、jpg' : "rar、zip、xls、xlsx、doc、docx" }} files.
                                Suggested uploads: Student's English transcript (if available), recent semester's transcript, etc.
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">Back to Previous Step</el-button>
                <el-button type="primary" class="btn" @click="subFn">Submit</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                  Thank you for your trust! Your information has been successfully submitted! <br>
                We have received your Assessment information. We will contact you as soon as possible to provide
                preliminary
                conclusions and suggestions. <br>
                If urgent processing is required, please indicate "urgent" in the message and specify the reason. The
                New Legend
                Visa Service Team is happy to assist you. <br>
                Our team comprises officially certified registered migration agents from Australia and New Zealand, who
                have
                been in the industry for 10 years and have achieved positive results for over 30,000 clients. <br>
                We are in Sydney, and our working hours are from 9:00 am to 5:30 pm Sydney time. You are also welcome to
                add our
                customer service WeChat for timely communication.
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">Restart Test</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [{
                title: "Basic Information",
                children: [
                    {
                        "name": "Student age group",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Primary school", },
                            { "name": "Junior high school", },
                            { "name": "High School", }
                        ]
                    },
                    {
                        "name": "Student Gender",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Male", },
                            { "name": "Female", }
                        ]
                    },
                    {
                        "name": "Proposed grade level",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Primary (小学)", },
                            { "name": "Year 7-9", },
                            { "name": "Year 10", }
                        ]
                    },
                    {
                        "name": "Type of current school",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Public", },
                            { "name": "Private", },
                            { "name": "International school", },
                            { "name": "Other/Home education", }
                        ]
                    },
                    {
                        "name": "English proficiency",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "基础", },
                            { "name": "Medium", },
                            { "name": "Good", },
                            { "name": "Near native", },
                            { "name": "No evaluation", },
                            { "name": "Already have English scores such as AEAS and IELTS", }
                        ]
                    },
                ]
            },
            {
                title: 'School preference',
                children: [
                    {
                        "name": "Preference for school type",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Public", },
                            { "name": "Private", }
                        ]
                    },
                    {
                        "name": "Budget (Tuition + Living Expenses/Year)",
                        "type": "radio",
                        "tip": "AUD stands for Australian Dollar",
                        "active": [],
                        "option": [
                            { "name": "Above AUD 50,000", },
                            { "name": "Above AUD 100,000", },
                            { "name": "Uncertain", }
                        ]
                    },
                    {
                        "name": "Is boarding required?",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Yes (boarding school)", },
                            { "name": "Yes (host family)", },
                            { "name": "No (Parental Accompanying/Local Guardian)", }
                        ]
                    },
                ]
            },
            {
                title: 'Guardianship and Visa',
                children: [
                    {
                        "name": "Is there a compliant guardian?",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Yes (immediate family member/compliant guardian in Australia)", },
                            { "name": "None (requires guardianship and welfare arrangements)", },
                        ]
                    },
                    {
                        "name": "Whether parents accompany their children to study",
                        "type": "radio",
                        "tip": "",
                        "active": [],
                        "option": [
                            { "name": "Required (590/Other)", },
                            { "name": "Not required", }
                        ]
                    },
                    {
                        "name": "Whether there is a history of visa rejection",
                        "type": "radio",
                        "tip": "Special instructions (if you hope to compete for elite/private school scholarships, please specify your goals and your child's strengths in the message; other requirements that parents need to specify)",
                        "active": [],
                        "option": [
                            { "name": "None", },
                            { "name": "Visa rejection in Australia", },
                            { "name": "Visa rejection by other countries", }
                        ]
                    }
                ]
            }],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 1,
                reportType: '2',
                source: '',
                passport_code: '',
                passport_type: '',
                parents_name: '',
                parents_relation: '',
                wx_code: '',
                nameen: ''
            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("Please upload only one file");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("上传成功");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('Please enter your name')
                return
            }
            if (!this.form.email) {
                this.$message.error('Please enter your email')
                return
            } 
            if (!this.form.wx_code) {
                this.$message.error('Please enter your WeChat account number')
                return
            }
            this.$http.review_add1({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                reviewFileUrl: this.file_url,
                about: this.form.about,
                type_id: this.form.type_id,
                source: this.form.source,
                passport_code: this.form.passport_code,
                passport_type: this.form.passport_type,
                parents_name: this.form.parents_name,
                parents_relation: this.form.parents_relation,
                wx_code: this.form.wx_code,
                reviewtext: JSON.stringify(this.questionList),
                // reviewNum: this.score,
                nameen: this.form.nameen,
            }).then(res => {
                console.log(res, '------')
                this.$message.success('Submit successfully')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }

        .btn {
            margin: 20px auto 0;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }

        .question-list:nth-child(2n) {
            border-left: 1px solid #ccc;
        }

        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/evaluateSmallStudent.vue